export default {
  created () {
    this.$store.subscribe((mutation) => {
      if (mutation.type === 'clearFilters' && typeof this.loadOptions === 'function') {
        this.options = this.loadOptions()
      }
    })
  }
}